import {createSelector} from '@reduxjs/toolkit'

const additionalCollectorQuestionSelector = createSelector(
    [state => state.components],
    (components) => {
        return components.additionalCollectorQuestion
    }
)

export const additionalCollectorQuestionSelect = state => ({
    additionalCollectorQuestion: additionalCollectorQuestionSelector(state)
})
